/* eslint-disable global-require */
/* eslint-disable func-names */
import EDC from './globals';

/**
 *
 */
EDC.Preloaders.Question = function (scene) {
  scene.load.spritesheet('global-question-mark', require('@/components/games/shared/assets/question-mark.png'), { frameWidth: 59, frameHeight: 84, endFrame: 3 });
};
/**
 *
 */
EDC.Animations.Question = function (scene) {
  this.scene = scene;
  this.questionMark = null;
  return this;
};
/**
 *
 */
EDC.Animations.Question.prototype.setup = function () {
  this.scene.anims.create({
    key: 'global-question-blinking',
    frames: this.scene.anims.generateFrameNumbers('global-question-mark', { start: 0, end: 2, first: 0 }),
    frameRate: 3,
    repeat: -1,
  });
};
/**
 *
 */
EDC.Animations.Question.prototype.create = function (x, y) {
  this.setup();

  this.questionMark = this.scene.add.sprite(x, y, 'global-question-mark').setOrigin(0, 0);
  this.questionMark.play('global-question-blinking');
};
/**
 *
 */
EDC.Animations.Question.prototype.moveTo = function (newX, newY) {
  this.scene.tweens.add({
    targets: this.questionMark,
    x: newX,
    y: newY,
    duration: 180,
    ease: 'Linear',
  });
};
/**
 *
 */
EDC.Animations.Question.prototype.getX = function () {
  return this.questionMark.x;
};
/**
 *
 */
EDC.Animations.Question.prototype.getY = function () {
  return this.questionMark.y;
};
/**
 *
 */
EDC.Animations.Question.prototype.show = function () {
  this.questionMark.setAlpha(1);
};
/**
 *
 */
EDC.Animations.Question.prototype.hide = function () {
  this.questionMark.setAlpha(0);
};

const exportPreloader = EDC.Preloaders.Question;
const exportQuestion = EDC.Animations.Question;

export { exportPreloader as QuestionPreloader, exportQuestion as Question };
